import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Users, ShieldCheck, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const benefits = [{
  title: "Adaptabilité et Relationnel",
  description: "L'une de nos principales forces réside dans notre capacité à adapter le déroulement de la visite au profil de l'acquéreur et aux spécificités du chantier. Lors de ce moment parfois anxiogène pour l'acquéreur, la finesse du relationnel est au coeur de notre vision et nous permet de mener toutes les visites avec écoute, échange et sérennité.",
  icon: Users
}, {
  title: "Expertise Éprouvée",
  description: "Avec 18 ans d'expérience, nos équipes maîtrisent parfaitement les processus de livraison et de manière plus gobale, le déroulement complet d'une opération de promotion.\nNotre activité de Maitrise d'Oeuvre nous confère également toute l'expertise technique nécessaire pour répondre avec précision à toutes les questions des acquéreurs.",
  icon: ShieldCheck
}, {
  title: "Constance et Proximité",
  description: "Avec NSDB, vous ferez rapidement connaissance avec l'ensemble de l'équipe d'experts AMO, très attachée à une relation de proximité et de confiance. Pas de turnover, pas de sous-traitance à outrance. Seulement des experts internes et 3 partenaires de longue date qui mettent toute leurs compétences au respect de vos exigences et à la satisfaction de vos acquéreurs.",
  icon: MapPin
}];
export default function KeyBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="key-benefits" className="relative w-full bg-primary overflow-hidden !opacity-[1] !rounded-none ![padding:60px_0px_60px_0px]">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: `linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)`,
      backgroundSize: '40px 40px'
    }} />

      <h2 className="relative z-10 text-center text-3xl md:text-4xl font-sans font-medium text-primary-foreground mb-16 px-4">Nos atouts et nos engagements</h2>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {benefits.map((benefit, i) => <div key={i} data-index={i} className="h-full">
              <Card className="group relative h-full bg-card border border-border rounded-[2px] shadow-sm transition-all duration-300 hover:scale-[1.02] overflow-hidden">
                {}
                <div className="absolute bottom-0 left-0 w-full h-[3px] bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />

                <CardHeader className="pb-4 pt-8 px-8">
                  <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary">
                    <benefit.icon strokeWidth={1.5} className="w-6 h-6" />
                  </div>
                  <CardTitle className="font-sans font-medium text-2xl text-foreground tracking-tight">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-8 pb-8">
                  <CardDescription className="font-sans text-base text-muted-foreground leading-relaxed !text-left">
                    {benefit.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}